// extracted by mini-css-extract-plugin
export default {"control":"control_control__pkxA6","button":"control_button__UHbD+"};